import { render, staticRenderFns } from "./Jan21.vue?vue&type=template&id=6a3ac1bd&scoped=true&"
import script from "./Jan21.vue?vue&type=script&lang=js&"
export * from "./Jan21.vue?vue&type=script&lang=js&"
import style0 from "./Jan21.vue?vue&type=style&index=0&id=6a3ac1bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3ac1bd",
  null
  
)

export default component.exports